import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SLICE_NAMES } from '../constants';

export interface IRedirectState {
  redirectUrl: string | null;
}

const initialState: IRedirectState = {
  redirectUrl: null,
};

const redirectSlice = createSlice({
  name: SLICE_NAMES.REDIRECT,
  initialState,
  reducers: {
    setRedirectUrl: (state, action: PayloadAction<string | null>) => {
      state.redirectUrl = action.payload;
    },
  },
});

export const { setRedirectUrl } = redirectSlice.actions;

export const redirectReducer = redirectSlice.reducer;
